export default __webpack_public_path__ + "static/media/StevenRiva_DL_Project.4a653735.pdf";